import { render, staticRenderFns } from "./CodigoExistente.vue?vue&type=template&id=4836b54c&scoped=true"
import script from "./CodigoExistente.vue?vue&type=script&lang=js"
export * from "./CodigoExistente.vue?vue&type=script&lang=js"
import style0 from "./CodigoExistente.vue?vue&type=style&index=0&id=4836b54c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836b54c",
  null
  
)

export default component.exports